import { FunctionalitiesEnum } from '@/config/types';
import { getSpecialRoutePath } from '@/logic/main/utils';
import { loginOpen, loginWatcher } from '@/model/login/kraken';
import { sessionWatcher } from '@/model/session/kraken';
import MessageBus from '@/ports-frontend/MessageBus';
import Window from '@/ports-frontend/Window';

function fireOpenDepositEvent(isQuickDepositEnabled: boolean) {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.header.deposit.open',
    data: {
      type: isQuickDepositEnabled ? 'QUICK_DEPOSIT' : 'DEPOSIT',
    },
  });
}

export async function openDeposit() {
  const stopSessionWatcher = await sessionWatcher({
    callback: async ({ type }) => {
      if (type === 'SESSION_STATE_LOGGED_OUT') {
        const stopLoginWatcher = await loginWatcher({
          callback: async ({ type }) => {
            if (type === 'LOGIN_MODAL_STATE_CLOSED') {
              stopSessionWatcher();
              stopLoginWatcher();
            }
          },
        });

        loginOpen();
      } else if (type === 'SESSION_STATE_LOGGED_IN') {
        const kraken = await Window.getKraken();

        fireOpenDepositEvent(kraken?.quickDepositEnabled);
        stopSessionWatcher();
      }
    },
  });
}

export async function depositCloseWatcher({
  callback,
}: {
  callback: Function;
}) {
  MessageBus.onSubscribe(
    ({ payload }) => {
      return callback({
        type: 'DEPOSIT_MODAL_STATE_CLOSED',
        data: payload,
      });
    },
    ['wh.common.event.ui.header.deposit.closed']
  );
}

export async function depositOpenWatcher({ callback }: { callback: Function }) {
  MessageBus.onSubscribe(
    ({ payload }) => {
      return callback({
        type: 'DEPOSIT_MODAL_STATE_OPENED',
        data: payload,
      });
    },
    ['wh.common.event.ui.header.deposit.opened']
  );
}

export function hideBalance() {
  MessageBus.publishEvent({
    topic: 'wh.kraken.command.myaccount.balance.hide',
  });
}

export function showBalance() {
  MessageBus.publishEvent({
    topic: 'wh.kraken.command.myaccount.balance.show',
  });
}

export function hideMyAccountDropdown() {
  MessageBus.publishEvent({
    topic: 'wh.myAccount.command.dropdown.close',
  });
}

export function openSelfExclusion() {
  MessageBus.publishEvent({
    topic: 'wh.myAccount.command.myAccountView.open',
    data: { myAccountView: 'selfExclusion' },
  });
}

function accountItemMap(
  type:
    | 'deposit'
    | 'responsibleGambling'
    | 'transactionHistory'
    | 'transferToPoker'
    | 'contactUs'
) {
  const map = {
    deposit: {
      topic: 'wh.common.event.ui.header.deposit.requested',
      data: {
        eventSource: 'Gaming',
      },
    },
    responsibleGambling: {
      topic: 'wh.myAccount.command.dropdown.open',
      data: {
        path: 'saferGambling',
      },
    },
    transactionHistory: {
      topic: 'wh.myAccount.command.dropdown.open',
      data: {
        path: 'accountHistory',
      },
    },
    transferToPoker: {
      topic: 'wh.myAccount.command.modals.open.pokerBalanceTransfer',
      data: {},
    },
    contactUs: {
      topic: 'live-person.open',
    },
  };

  return map[type];
}

export function openingAccountItemModal(
  accountAction:
    | 'deposit'
    | 'responsibleGambling'
    | 'transactionHistory'
    | 'transferToPoker'
    | 'contactUs'
) {
  const messageBusEvent = accountItemMap(accountAction);
  MessageBus.publishEvent(messageBusEvent);
}

export function accountWatcher({ callback }: { callback: Function }) {
  MessageBus.onSubscribe(
    data => {
      switch (data.message) {
        case 'wh.myAccount.event.viewPromotions':
          return callback({
            type: 'VIEW_PROMOTIONS_EVENT_CALLED',
            payload: {
              path: getSpecialRoutePath(FunctionalitiesEnum.promotions),
            },
          });
      }
    },
    ['wh.myAccount.event.viewPromotions']
  );
}
